/** 界面资源编码在网关传输边界统一转换，业务 DTO 保持服务端语言码。 */
export const toTransportLanguage = (locale: string): string =>
  (({ 'en-US': 'en', 'zh-TW': 'zh-HK' } as Record<string, string>)[locale] ??
  locale);

/** 实际值与回退来源一起返回；缺译状态仍由正式统计判断。 */
export function resolveTranslation(
  values: Record<string, string>,
  target: string,
  primary?: string,
  baseline?: string,
) {
  const chain = [
    ...new Set(
      [target, primary, baseline].filter((code): code is string => !!code),
    ),
  ];
  const lang = chain.find((code) => values[code]?.trim());
  return {
    value: lang ? values[lang] : undefined,
    lang,
    isFallback: lang !== undefined && lang !== target,
  };
}
